import React, { useEffect, useMemo, useRef, useState } from "react";
import { Link } from "react-router-dom";
import {
  RotateCcw,
  Plus,
  ChevronUp,
  Send,
  Printer,
  Search,
  Trash2,
  X,
} from "feather-icons-react/build/IconComponents";
import "../../style/css/product-master.css";
import { pmHue, pmInitials } from "../../components/master/modal/Product/pmUi";

import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import { Select } from "antd";
import Selectbranch from "../../components/master/modal/Selectbranch";
import {
  deleteProduct,
  getProductList,
} from "../../services/MasterApiServices";
import { ProductClass } from "../../core/json/ProductClass";
import {
  fetchCategory,
  fetchGroup,
  fetchProduct,
  // fetchProductAll,
  // fetchProductAll,
  fetchSection,
  fetchTax,
  fetchType,
  fetchUnit,
} from "../../redux/userSetting";
import AddProduct from "../../components/master/modal/AddProduct";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import { setheadertoggle } from "../../redux/toggle";
import EditProduct from "../../components/master/modal/Editproduct";
import {
  exportPDF,
  exportExcel,
  HandlePrint,
  renderTooltip,
} from "../../redux/helper";
import ProductBranchTransfer from "../../components/master/modal/Product/ProductBranchTransfer";
import LoadingUtils from "../../core/utils/LoadingUtils";
import {
  exportMasterExcel,
  exportMasterPDF,
  printMasterReport,
} from "../../core/utils/MasterReportUtils";
import { fetchBranchSettings } from "../../redux/settingbyBranch";
import toast from "react-hot-toast";
import { ProductPos } from "../../core/json/ProductPos";
 
const Product = () => {
  const dispatch = useDispatch();
  const [searchText, setSearchText] = useState("");
  const [updateData, setUpdateData] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedType, setselectedType] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalMode, setModalMode] = useState("add");
  const { togglehead } = useSelector((state) => state.headerToggle);
  const { branch } = useSelector((state) => state.branchlist);
  const { productloading } = useSelector(
    (state) => state.usersetting
  );
  // Get user from redux
  const { userId } = useSelector((state) => state.userauth);
  const { menuItems, specialpermission } = useSelector((state) => state.amc);
  const [permit, setpermit] = useState();
  const [branchpermit, setbranchpermit] = useState();
  const handletogglehead = () => {
    dispatch(setheadertoggle(!togglehead));
  };
  const { formattedTypeList, formattedCategoryList,productList } = useSelector(
    (state) => state.usersetting
  );
  const { sectionList, taxList, deliveyTypes, unitList, groupList } =
    useSelector((state) => state.usersetting);
 
  useEffect(() => {
    dispatch(fetchCategory(branch.guid));
    // dispatch(fetchSection(branch.guid));
    dispatch(fetchGroup(branch.guid));
    dispatch(fetchProduct(branch));
    dispatch(fetchBranchSettings(branch.guid));
  }, [branch]);
 
  useEffect(() => {
    // dispatch(fetchProductAll())
    dispatch(fetchType());
    dispatch(fetchUnit());
    dispatch(fetchTax());
    setbranchpermit(
      specialpermission?.userSpecialPermissionList?.find(
        (e) => e.specialPermission.name == "Product Branch Transfer"
      )
    );
    setpermit(
      menuItems?.menuPermissions?.find((e) => e.menu.name == "Product")
    );
  }, []);
 
  const handleSearch = (e) => {
    setSearchText(e.target.value);
  };
  function handleAddProduct() {
    if (formattedTypeList.length <= 0) {
      toast.error("Please enter type before adding product");
      return;
    }
    if (formattedCategoryList.length <= 0) {
      toast.error("Please enter categroy before adding product");
      return;
    }
    if (unitList.length <= 0) {
      toast.error("Please enter unit before adding product");
      return;
    }
    if (groupList.length <= 0) {
      toast.error("Please enter group before adding product");
      return;
    }
    // if (sectionList.length <= 0) {
    //   toast.error("Please enter section before adding product");
    //   return;
    // }
     else {
      setModalMode("add");
      setModalOpen(true);
    }
  }
  function handleReset() {
    setselectedType(null);
    setSelectedCategory(null);
    setSearchText("");
  }
  const modifiedList = productList?.filter((product) => {
    const searchMatch =
      product.name?.toLowerCase().includes(searchText?.toLowerCase()) ||
      product.code?.toLowerCase().includes(searchText?.toLowerCase());
    const categoryMatch = selectedCategory
      ? product?.category?.guid === selectedCategory
      : true;
    const itemMatch = selectedType
      ? product?.type?.guid === selectedType
      : true;
    console.log("selectedType", selectedType);
    console.log("selectedType?.value", selectedType?.value);
    console.log("product?.type?.guid", product?.type?.guid);
    return searchMatch && categoryMatch && itemMatch;
  });
  const handleCategoryChange = (selectedOption) => {
    console.log("Selected category:", selectedOption);
    setSelectedCategory(selectedOption);
  };
 
  const handleTypeChange = (selectedOption) => {
    console.log("Selected type:", selectedOption);
    setselectedType(selectedOption);
  };
  const handleEditClick = async (guid) => {
    try {
      const SingleGroup = getProductGuid(guid);
      setUpdateData(SingleGroup); // Set the data for editing
    } catch (error) {
      console.error("Error fetching promotion GUID:", error);
    }
  };
  // Function to get a single object from filtering a list of group objects
  function getProductGuid(guid) {
    const filteredData = productList?.filter((group) => group.guid === guid);
    return filteredData[0];
  }
  // Initialize SweetAlert with ReactContent
 
  const MySwal = withReactContent(Swal);
  // Handle the click event to delete a group
  const handleDeleteClick = (obj) => {
    MySwal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#00ff00",
      cancelButtonColor: "#ff0000",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const objproduct = new ProductPos();
          objproduct.id = obj.id;
          objproduct.Branch = branch;
          objproduct.guid = obj.guid;
          objproduct.CategoryID =obj.CategoryID;
          objproduct.SubGroupID = obj.SubGroupID;
          objproduct.ItemTypeID = obj.ItemTypeID;
          objproduct.StockTypeID = obj.StockTypeID;
          objproduct.UnitID = obj.UnitID;
          objproduct.TaxID = obj.TaxID; 
          objproduct.ManufactureID = obj.ManufactureID;
          objproduct.ReorderLevel = obj.ReorderLevel;
          objproduct.MinQty = obj.MinQty;
          objproduct.MaxQty = obj.MaxQty;
          objproduct.MinPrice = obj.MinPrice;
          objproduct.IsSalesTaxIncludedInPrice = obj.IsSalesTaxIncludedInPrice;
          objproduct.IsPurchaseTaxIncludedInPrice = obj.IsPurchaseTaxIncludedInPrice;
          objproduct.ModifiedDate = new Date();
          objproduct.IsMenuItem = true;
          objproduct.updatedUser = `{${userId?.id}}`; //"{9b57619d-63c8-4e27-9a59-639f0c80e4a1}";
          const response = await deleteProduct(objproduct);
          console.log(objproduct);
 
          if (response) {
            MySwal.fire({
              title: "Deleted!",
              text: "The product has been deleted.",
              icon: "success",
              confirmButtonColor: "#00ff00",
              confirmButtonText: "OK",
            }).then(() => {
              dispatch(fetchProduct(branch)); // Refresh the list
              setSearchText(""); // Clear the search text
            });
          } else {
            MySwal.fire({
              title: "Error!",
              text: "Something went wrong.",
              icon: "error",
              confirmButtonColor: "#ff0000",
              confirmButtonText: "OK",
            });
          }
        } catch (error) {
          console.error("Error deleting group:", error);
          MySwal.fire({
            title: "Error!",
            text: error?.response?.data?.Message,
            icon: "error",
            confirmButtonColor: "#ff0000",
            confirmButtonText: "OK",
          });
        }
      }
    });
  };
  console.log(productList,"prooooooo");
  
  const columns = [
    {
      title: "Code",
      dataIndex: "prodCode",
      sorter: (a, b) => a.prodCode - b.prodCode,
    },
    {
      title: "Name",
      dataIndex: "name",
      sorter: (a, b) => a.name?.length - b.name?.length,
    },
    {
      title: "Short Name",
      dataIndex: "shortName",
    },
    {
      title: "Description",
      dataIndex: "shortDescription",
    },
    ...(permit?.edit || permit?.deletion
      ? [
          {
            title: "Actions",
            dataIndex: "actions",
            key: "actions",
          },
        ]
      : []),
  ];
  const getActiveTabData = () => {
    let fieldMapping = {};
 
    // Function to create the field mapping between column titles and dataIndex values
    const createfieldMapping = (columns) => {
      const mappings = {};
      columns.forEach((col) => {
        mappings[col.title] = col.dataIndex; // Map title to dataIndex
      });
      return mappings;
    };
 
    // Generate the field mapping for the current columns
    fieldMapping = createfieldMapping(columns);
 
    // Return the filtered data, columns, and field mapping
    return { data: modifiedList, columns: columns, fieldMapping, Rname: "Product"};
  };
  // ---- list presentation: sorting, batched rows, search highlight --------
  // Display only - the rows come straight from modifiedList above.
  const PM_BATCH = 50;
  const [pmSort, setPmSort] = useState({ key: "name", dir: 1 });
  const [pmShown, setPmShown] = useState(PM_BATCH);
  const pmListRef = useRef(null);
  const pmSentinelRef = useRef(null);

  const pmList = useMemo(() => {
    const collator = new Intl.Collator(undefined, {
      numeric: true,
      sensitivity: "base",
    });
    const pick = (p) => String((pmSort.key === "code" ? p?.prodCode : p?.name) ?? "");
    return [...(modifiedList || [])].sort(
      (a, b) => collator.compare(pick(a), pick(b)) * pmSort.dir
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productList, searchText, selectedCategory, selectedType, pmSort]);

  // back to the first batch whenever the result set changes
  useEffect(() => {
    setPmShown(PM_BATCH);
    if (pmListRef.current) pmListRef.current.scrollTop = 0;
  }, [searchText, selectedCategory, selectedType, pmSort]);

  // load the next batch as the bottom of the list scrolls into view
  useEffect(() => {
    const root = pmListRef.current;
    const target = pmSentinelRef.current;
    if (!root || !target || typeof IntersectionObserver === "undefined") return;
    if (pmShown >= pmList.length) return;
    const io = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) setPmShown((n) => n + PM_BATCH);
      },
      { root, rootMargin: "240px" }
    );
    io.observe(target);
    return () => io.disconnect();
  }, [pmShown, pmList.length]);

  // the product open on the right disappeared (deleted, or branch switched)
  useEffect(() => {
    if (
      modalOpen &&
      modalMode === "edit" &&
      updateData?.guid &&
      Array.isArray(productList) &&
      !productList.some((p) => p.guid === updateData.guid)
    ) {
      setModalOpen(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productList]);

  const pmToggleSort = (key) =>
    setPmSort((s) => (s.key === key ? { key, dir: -s.dir } : { key, dir: 1 }));
  const pmSortMark = (key) =>
    pmSort.key === key ? (pmSort.dir > 0 ? "↑" : "↓") : "";

  const pmQuery = (searchText || "").toLowerCase();
  const pmMark = (text) => {
    const s = String(text ?? "");
    const i = pmQuery ? s.toLowerCase().indexOf(pmQuery) : -1;
    if (i < 0) return s;
    return (
      <>
        {s.slice(0, i)}
        <mark>{s.slice(i, i + pmQuery.length)}</mark>
        {s.slice(i + pmQuery.length)}
      </>
    );
  };
  const pmMoney = (v) => {
    const n = Number(v);
    return Number.isFinite(n) ? n.toFixed(2) : "—";
  };

  // open a row in the right-hand panel (same as the old edit icon)
  const pmOpenEdit = (obj) => {
    handleEditClick(obj.guid);
    setModalMode("edit");
    setModalOpen(true);
  };
  const pmEditing = modalOpen && modalMode === "edit" && updateData?.guid;
  const pmFiltered = !!(searchText || selectedCategory || selectedType);

  return (
    <div className="pm-screen">
      <LoadingUtils loading={productloading} />
      <div className="page-wrapper pm-wrapper">
        <div className="content pm-page">
          {/* ============ COMMAND BAR ============ */}
          <header className="pm-cmd">
            <div className="pm-doc">
              <h1>Product</h1>
              <span className="pm-count">{productList?.length || 0} items</span>
            </div>
            <div className="pm-spacer" />
            <div className="pm-cmd-actions">
              <OverlayTrigger placement="top" overlay={renderTooltip("PDF")}>
                <Link
                  className="pm-iconbtn"
                  onClick={() => exportMasterPDF(getActiveTabData, "Product")}
                >
                  <ImageWithBasePath src="assets/img/icons/pdf.svg" alt="img" />
                  PDF
                </Link>
              </OverlayTrigger>
              <OverlayTrigger placement="top" overlay={renderTooltip("Excel")}>
                <Link
                  className="pm-iconbtn"
                  onClick={() => exportMasterExcel(getActiveTabData, "Product")}
                >
                  <ImageWithBasePath
                    src="assets/img/icons/excel.svg"
                    alt="img"
                  />
                  Excel
                </Link>
              </OverlayTrigger>
              <OverlayTrigger placement="top" overlay={renderTooltip("Print")}>
                <Link
                  className="pm-iconbtn"
                  onClick={() => printMasterReport(getActiveTabData, "Product")}
                >
                  <Printer />
                  Print
                </Link>
              </OverlayTrigger>
              <OverlayTrigger
                placement="top"
                overlay={renderTooltip("Refresh")}
              >
                <Link
                  className="pm-iconbtn"
                  aria-label="Refresh"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  onClick={() => dispatch(fetchProduct(branch))}
                >
                  <RotateCcw />
                </Link>
              </OverlayTrigger>
              <OverlayTrigger
                placement="top"
                overlay={renderTooltip("Collapse")}
              >
                <Link
                  aria-label="Collapse"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  id="collapse-header"
                  className={"pm-iconbtn" + (togglehead ? " active" : "")}
                  onClick={handletogglehead}
                >
                  <ChevronUp />
                </Link>
              </OverlayTrigger>
              {branchpermit?.userRole.id !== 0 && (
                <>
                  <span className="pm-sepbar" />
                  <Link
                    to="#"
                    className="pm-btn-soft"
                    data-bs-target="#product-branch-trans"
                    data-bs-toggle="modal"
                  >
                    <Send />
                    Branch Transfer
                  </Link>
                </>
              )}
            </div>
          </header>

          <div className="pm-grid">
            {/* ============ LIST ============ */}
            <section className="pm-listpanel">
              <div className="pm-searchrow">
                <div className="pm-searchwrap">
                  <Search />
                  <input
                    type="text"
                    placeholder="Search name or code — any part"
                    className="pm-search"
                    aria-controls="DataTables_Table_0"
                    value={searchText}
                    onChange={handleSearch}
                  />
                </div>
                {permit?.add && (
                  <Link to="#" className="pm-btn-new" onClick={handleAddProduct}>
                    <Plus />
                    New
                  </Link>
                )}
              </div>

              <div className="pm-filters">
                <Select
                  className={"img-select pm-fsel" + (selectedType ? " on" : "")}
                  options={formattedTypeList}
                  value={selectedType}
                  onChange={handleTypeChange}
                  classNamePrefix="react-select"
                  placeholder="Select Type"
                />
                <Select
                  className={
                    "img-select pm-fsel" + (selectedCategory ? " on" : "")
                  }
                  options={formattedCategoryList}
                  value={selectedCategory}
                  onChange={handleCategoryChange}
                  classNamePrefix="react-select"
                  placeholder="Select Category"
                />
                <button
                  type="button"
                  className="pm-clearfilters"
                  onClick={handleReset}
                  disabled={!pmFiltered}
                  title="Reset search and filters"
                  aria-label="Reset search and filters"
                >
                  <X />
                </button>
              </div>

              <div className="pm-listhead">
                <span />
                <span>
                  <button
                    type="button"
                    className="pm-sortbtn"
                    onClick={() => pmToggleSort("name")}
                  >
                    Product {pmSortMark("name")}
                  </button>
                  <button
                    type="button"
                    className="pm-sortbtn"
                    onClick={() => pmToggleSort("code")}
                  >
                    Code {pmSortMark("code")}
                  </button>
                </span>
                <span className="r">Retail</span>
                <span />
              </div>

              <div className="pm-listwrap" ref={pmListRef}>
                {pmList.slice(0, pmShown).map((p) => (
                  <div
                    key={p.guid || p.id}
                    role="button"
                    tabIndex={permit?.edit ? 0 : -1}
                    className={
                      "pm-prow" +
                      (pmEditing && updateData.guid === p.guid ? " sel" : "") +
                      (permit?.edit ? "" : " ro")
                    }
                    onClick={permit?.edit ? () => pmOpenEdit(p) : undefined}
                    onKeyDown={(e) => {
                      if (permit?.edit && (e.key === "Enter" || e.key === " ")) {
                        e.preventDefault();
                        pmOpenEdit(p);
                      }
                    }}
                    title={p.shortDescription || ""}
                  >
                    <span
                      className="pm-thumb"
                      style={{
                        "--h": pmHue(p?.category?.guid || p?.categoryID || p?.name),
                      }}
                    >
                      {pmInitials(p.name)}
                    </span>
                    <span className="pm-pmain">
                      <span className="pm-pname">{pmMark(p.name)}</span>
                      <span className="pm-psub">
                        <span className="pm-code">{pmMark(p.prodCode)}</span>
                        {p.shortName ? (
                          <>
                            {" · "}
                            <span className="pm-ar" dir="auto">
                              {p.shortName}
                            </span>
                          </>
                        ) : null}
                      </span>
                    </span>
                    <span className="pm-pprice">
                      {pmMoney(p.retailRate)}
                      <i>retail</i>
                    </span>
                    <span className="pm-pacts">
                      {permit?.deletion && (
                        <button
                          type="button"
                          className="pm-rowbtn del"
                          title="Delete"
                          aria-label={`Delete ${p.name || "product"}`}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleDeleteClick(p);
                          }}
                        >
                          <Trash2 />
                        </button>
                      )}
                    </span>
                  </div>
                ))}
                <div className="pm-sentinel" ref={pmSentinelRef} />
                {pmShown < pmList.length && (
                  <div className="pm-loadmore">
                    <button
                      type="button"
                      onClick={() => setPmShown((n) => n + PM_BATCH)}
                    >
                      Load {PM_BATCH} more
                    </button>
                  </div>
                )}
                {!pmList.length && !productloading && (
                  <div className="pm-noresult">
                    <div className="big">Nothing matches</div>
                    <div>Try a shorter search, or reset the filters.</div>
                  </div>
                )}
              </div>

              <div className="pm-listfoot">
                <span>
                  Showing <b>{Math.min(pmShown, pmList.length)}</b> of{" "}
                  <b>{pmList.length}</b>
                </span>
                <span className="right">
                  {pmShown >= pmList.length
                    ? "all loaded"
                    : `${PM_BATCH} per batch · scroll for more`}
                </span>
              </div>
            </section>

            {/* ============ DETAIL ============ */}
            {modalOpen && modalMode === "add" ? (
              <AddProduct handleClose={() => setModalOpen(false)} />
            ) : pmEditing ? (
              <EditProduct
                key={updateData.guid}
                data={updateData}
                handleClose={() => setModalOpen(false)}
              />
            ) : (
              <section className="pm-detail pm-dempty">
                <div className="in">
                  <svg
                    viewBox="0 0 48 48"
                    width="40"
                    height="40"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.6"
                    aria-hidden="true"
                  >
                    <path d="M24 5 42 14v20L24 43 6 34V14z" />
                    <path d="M6 14l18 9 18-9M24 23v20" />
                  </svg>
                  <h2>Pick a product</h2>
                  <p>
                    Select a product on the left to edit it here
                    {permit?.add ? ", or press New to add one" : ""}. The list
                    stays put while you work.
                  </p>
                </div>
              </section>
            )}
          </div>
        </div>
        <Selectbranch />
        <ProductBranchTransfer />
      </div>
    </div>
  );
};
 
export default Product;
 
 